import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './index.css';

const Success: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    // Get all parameters from URL
    const params = new URLSearchParams(location.search);
    const sessionId = params.get('session_id');
    const orderId = params.get('order_id');
    const hogcloudInvoiceId = params.get('hogcloud_invoice_id');
    const isPickup = params.get('is_pickup');
    const isStoreFrontOrder = params.get('is_storefront_order');

    // Redirect to order complete page after a brief delay
    const timer = setTimeout(() => {
      if (sessionId) {
        // Build the URL with all parameters
        const orderCompleteUrl = `/order-complete?session_id=${sessionId}&order_id=${orderId}${hogcloudInvoiceId ? `&hogcloud_invoice_id=${hogcloudInvoiceId}` : ''}${isPickup ? `&is_pickup=${isPickup}` : ''}${isStoreFrontOrder ? `&is_storefront_order=${isStoreFrontOrder}` : ''}`;
        navigate(orderCompleteUrl);
      } else {
        navigate('/order-complete');
      }
    }, 2000);

    return () => clearTimeout(timer);
  }, [navigate, location]);

  return (
    <div className="success-container">
      <div className="success-content">
        <div className="success-icon">✅</div>
        <h1>Payment Successful!</h1>
        <p>Your order has been processed successfully.</p>
        <p className="redirect-message">Redirecting to your order details...</p>
      </div>
    </div>
  );
};

export default Success; 
